import { createSlice } from "@reduxjs/toolkit";

// El detalle de objetivos del plan de terapia: que objetivos del catalogo de
// objetivos de temas de evaluacion (objetivocatalogo) se siguen en el plan.
// El detalle es plan + objetivo + orden: el area ya no interviene.
const defaultObjetivo = {
    id: 0,
    numero: 0,
    idObjetivoCatalogo: null,
    objetivo: "",
    descripcion: "",
    orden: 1,
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
    objetivosCatalogo: [],
};

const initialState = {
    defaultEntity: [],
    entity: [],
    validationActive: {},
    validationMessage: [],
};

export const therapyPlanObjetivoSlice = createSlice({
    name: "therapyPlanObjetivo",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            // El detalle se muestra en el orden que dio el terapeuta: el campo
            // Orden de cada fila manda.
            const rows = Array.isArray(action.payload) ? action.payload : (action.payload ? [action.payload] : []);

            state.entity = rows.map((row, index) => ({
                ...defaultObjetivo,
                ...row,
                numero: row.numero || (index + 1),
                orden: row.orden || (index + 1),
            }));
        },
        setData: (state, action) => {
            const { numero, name, value } = action.payload;
            const row = state.entity.find((x) => x.numero == numero);

            if (row) row[name] = value;
        },
        add: (state, action) => {
            const numero = state.entity.length + 1;

            state.entity.push({
                ...defaultObjetivo,
                id: 0,
                numero: numero,
                orden: numero,
            });
        },
        remove: (state, action) => {
            state.entity = state.entity.filter((x) => x.numero != action.payload);
        },
        setValidations: (state, action) => {
            state.validationMessage = action.payload || [];
        },
        activeValidations: (state) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            });
        },
    },
});

export const { setEntity, setData, add, remove, setValidations, activeValidations } = therapyPlanObjetivoSlice.actions;
export default therapyPlanObjetivoSlice.reducer;
